import { render, staticRenderFns } from "./seat-selection.vue?vue&type=template&id=8c7b5d74"
import script from "./seat-selection.vue?vue&type=script&lang=js"
export * from "./seat-selection.vue?vue&type=script&lang=js"
import style0 from "./seat-selection.vue?vue&type=style&index=0&id=8c7b5d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports